module.exports = __webpack_public_path__ + "media/images/application/template/icon--link-external-e1f01c2e83b959b88dae2047af8134c0.svg";